import { S } from '@angular/cdk/keycodes';

// USA
export const locale = {
	lang: 'en',
	data: {
		TRANSLATOR: {
			SELECT: 'Select your language',
		},
		MENU: {
			PRICE:'Contract Price Master',
			COM:'Compensation',
			STOCK:'Stock Master',
			APP:'Application',
			SEG:'Segment',
			CALL:'Customer Call Tracking',
			PRODUCTIVITY: 'Productivity Report',
			DISCOUNTAPPROVE:'Discount Price Approval',
			LEADERBOARD: 'LeaderBoard',
			REIM: 'Reimbursement',
			TRAININGSCORE: 'Training Score',
			TRANSFERSPARE: 'Spare Transfer Request',
			IMPRESTSPARE: 'Imprest Spare Request',
			NEW: 'new',
			ACTIONS: 'Actions',
			CREATE_POST: 'Create New Post',
			PAGES: 'Pages',
			FEATURES: 'Features',
			APPS: 'Apps',
			DASHBOARD: 'Dashboard',
			NEW_SUBSCRIPTION: 'New Subscription',
			KNOWLEDGE: 'Knowledge Based',
			MANAGE_SUBSCRIPTION: 'Manage Subscription',
			PRODUCT_MASTER: 'Product Master',
			SLA_MAPPING: 'SLA Mapping',
			// BILLING_DETAILS: 'Dashboard',
			PACKAGE_TYPE: 'Package Type',
			PACKAGE_PLAN: 'Package Plan',
			PACKAGE_MANAGEMENT: 'Package Management',
			PACKAGE_CONFIGURATION: 'Package Configuration',
			WAREHOUSE: 'Warehouse Master',
			SPARE: 'Spare Master',
			INVENT:'Update Inventory',
			SERVICE: 'Sevice Group',
			AMC: 'AMC Type Management',
			SITE: 'Site Settings',
			SMTP: 'SMTP Settings',
			SMS: 'SMS Settings',
			// ORG_STR: 'Organization Structure',
			CUSTOMERMANAGEMENT: 'Customer Management',
			CONTENT: 'Content Management',
			USER: 'User Management',
			CREATE: 'Create',
			LOCATION: 'Locaion Mapping',
            REGION:'Region',
			RAISETCKT: 'Raise Ticket',
			NEWTCKT: 'New Tickets',
			CONFIG: 'Configuration',
			PERFORMANCEMATRIX: 'Performance Metrix',
			COMPLETEDTKT: 'Completed Tickets',
			AMCCON: 'Contract Renewal',
			CSAT: 'C-Sat',
			MENU:'Model Master',
			ALL:'All Ticket',
            SS: 'Support Scope Master',
			FRM: 'FRM Update',
			TRC:'TRC Update',
			TRC_LO:'TRC Location',
			UPDATE_SLA:'Update SLA',
			ACCTI:'Acceptance Time '
		},
		AUTH: {
			GENERAL: {
				OR: 'Or',
				// SUBMIT_BUTTON: 'Submit',
				NO_ACCOUNT: 'Don\'t have an account?',
				// SIGNUP_BUTTON: 'Sign Up',
				// FORGOT_BUTTON: 'Forgot Password',
				BACK_BUTTON: 'Back',
				PRIVACY: 'Privacy',
				LEGAL: 'Legal',
				CONTACT: 'Contact',
			},
			LOGIN: {
				TITLE: 'Login Account',
				BUTTON: 'Sign In',
			},
			FORGOT: {
				TITLE: 'Forgot Password?',
				DESC: 'Enter your email to reset your password',
				SUCCESS: 'Your account has been successfully reset.'
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.'
			},
			INPUT: {
				// EMAIL: 'Email',
				FULLNAME: 'Full Name',
				// PASSWORD: 'Password',
				CONFIRM_PASSWORD: 'Confirm Password',
				// USERNAME: 'Username'
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'Required field',
				VALID_ADDRESS: 'Enter a valid email address',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Field is not valid',
				// ACPT_NUM: 'Accept only numbers',
				ENTER_PASSWORD: 'Enter your password',
				ENTER_EMAIL: 'Enter your email',
				INVALID_EMAIL: 'Email is not valid',
				SPACE_VALID: 'Please enter valid'
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				// ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
		PRODUCT_MASTER: {
			PARA: 'A washing machine is a machine that washes dirty clothes....This barrel is filled with water, and then rotated very quickly to make the water remove dirt from the clothes. Most washing machines are made so 	that detergent (liquids or powders) can be put into the machine. These can help make the clothes cleaner.',

		},
		NEW_SUBSCRIPTION: {
			// MANAGE: 'Manage Subscription',
			CREATE: 'Create Subscription',
			SERIAL_NO: 'S.No',
			ORG: 'Enter Organization Name',
			CANCEL: 'Cancel',
			CLOSE:'Close',
			CONTACT: 'Contact Person Name',
			// ENTER_CONTACT_NAME: 'Contact Person Name',
			// CONTACT_NO: 'Contact Number',
			ENTER_CONTACT: 'Enter Contact Number',
			ORG_TYPE: 'Organization Type',
			// TOTPRICE: 'Total Price',
			TOT_LICENSE: 'License availed',
			USED_lICENSE: 'License used',
			ACTION: 'Action',
			RENEW: 'Renew',
			EXTENT_DURATION: 'Extend Duration',
			MORE: 'Buy More',
			REMOVE: 'Remove License',
			ACTIVE: 'Active',
			BLOCK: 'Blocked',
			COMPANY_INFO: 'Company Info',
			ADDRESS: 'Address',
			// CONFIRM_DETAILS: 'Confirm Details',
			PACKAGE_TYPE: 'Package type',
			// PACKAGE_PLAN: 'Package plan',
			PACKAGE_DETAILS: 'Package details',
			ENTER: 'Enter Company Details',
			// ADD: 'Address',
			DET: 'Confirm Details',
			ORGNAME: 'Organization Name',
			NAME: 'Company Name',
			LOGO: 'Upload Logo',
			LOG: 'Logo',
			USELICENSE: 'Number of used License',
			LICENCE: 'Number of License',
			ENTER_LICENCE: 'Enter No Of Licence',
			CONNAME: 'Contact Name',
			// CONNUMBER: 'Contact Number ',
			// CONALTNUMBER: 'Alternate Number',
			CONALT_NUMBER: 'Enter Alternate number',
			EMAIL: 'Email',
			ENTER_EMAIL: 'Enter Your Email',
			SUBPACK: 'Subscription Package',
			SUBPLAN: 'Subscription Plan',
			PACKAMT: 'Package Amount',
			DOPLO: 'Door/Plot No',
			ENTER_DOPLO: 'Enter Door/Plot No',
			STR: 'Street/Locality',
			ENTER_STR: 'Enter Street/Locality',
			// TOWN: 'Town',
			// ENTER_LAND: ' Enter LandMark',
			LAND: ' Enter LandMark',
			// AND: 'LandMark',
			COUNTRY: 'Country',
			// POSCODE: 'Postal Code',
			ENTER_POSCODE: 'Enter Postal Code',
			// AMT: 'Amount',
			AMTP: 'Amount paid',
			DISCOUNTPERCENT: 'Discount percentage',
			CALCULATE: 'Calculate',
			// DISCOUNTAMT: 'Discount Amount',
			NEW_PER_LICENSECOST: 'New cost per license',
			// TOT_PRICE: 'Total Price',
			ENTER_PRICE: 'Enter Total Price',
			DISCOUNT_PRICE: 'Discount price',
			REQ: 'is required',
			// DIGI: 'must be 10 digits',
			PRBLMDESC: 'must be 250 characters only',
			VALID: 'Please enter a valid',
			SELECT: 'Select a',
			SHO: 'should be in characters, / ,Digits',
			FRTR: 'Free Trail',
			GOLD: 'Gold',
			SILVER: 'Silver',
			PLATINUM: 'Platinum',
			// MUST: 'must be in 6 digits',
			NEXT_STEP: 'Next Step',
			SNEXT_STEP: 'Save And Next',
			PREVIOUS: 'Previous',
			// SUB: 'Submit',
			OK: 'OK',
			STATUS: 'Status',
			THISFIELD: 'This field',
			// END_DATE: 'End Date',
			EXTEND_DAYS: 'Days To be extended',
			NEW_NOLICENSE: 'New No of license',
			REMOVELICENE: 'No of License to remove',
			VIEW_SUBSCRPTION: 'View Subscription',
			EDIT_SUBSCRIPTION: 'Edit Subscription',
			RENEW_SUBSCRIPTION: 'Renew Subscription',
			REMOVE_SUBSCRIPTION: 'Remove Subscription',
			MANDATORY: 'All Fields are Mandatory',
			MORE_SUBSCRIPTION: 'Buy More Subscription',
			ADD_NOLICENSE: 'No of License to Add',
			USERINFO: 'User Details',
			AIFO: 'Address',
			WORKINFO: 'Work Geography',
			COULD: 'Please enter a valid 6 digit Postal code',
			SELECT_SEL:'Select',
			SINGLE_ORG:'Single Organization',
			MULTI_ORG:'Multiple Organization',
			CONTRACT_DET:' Contract Details',
			LOGIN_CRE:'Login creation ',
			CUS_CRM_ID:'Customer CRM ID',
			ASSET_DET:'Asset Details',
			VIEW_LESS:'View Less',
			PM_DET:'PM Details',
			PM_INTER_DAY:'PM Interval(in days)',
			TOT_CONTRACT_PRICE:'Total Contract Price',
			VIEW_ASSET_DET:'View Asset Details',
			DIS_VALUE:'Discount Value',
			CONT_INFO:'Contract Information',
			BLOCKED:'Block',
			SELECT_SUPPORT_SCOPE:'Select Supportscope type',
			ENUSEDE:'End user Details',
			SEUSE:'Select End User',
			COMDEL:'Complaint Details',
			ADD_NEW: 'Add New Subscription',
		},
		PACKAGE_PLAN: {

			TITLE: 'Create Package Plan',
			ADD_PACKAGE: 'Add Package',
			EDIT_PACKAGE: 'Edit Package',
			// PACKAGE_PLAN: 'Package Plan',
			RANGE: 'Range',
			LICENSE_COST: 'License Cost',
			NEWLICENSE_COST: 'New License cost',
			DISC_PERCENT: 'Enter Discount Percentage',
			// DISC_AMT: 'Discount Amount',
			NEWCOST: 'New cost',
			// ACTIVE: 'Active',
			// BLOCK: 'Blocked',
			FROM: 'From',
			TO: 'To',
			EFROM: 'Enter From range',
			TFROM: 'Enter To range',
			DISCOUNT_PRICE: 'Enter Discount Price',
			TOT_PRICE: 'Total Price',
			UPDATE: 'Update',
			PLAN: 'Plan',
			DISCOUNTPERCENT: 'Discount Percentage',
			PER:'Percentage',
			NO_DIS:'No Discount',
			PAC_ID:'packageid',
			FREE:'Free',
			PAID:'Paid'

		},
		PRICE:{
			ADD_PRICE:'Add Contract Price',
			EDIT_PRICE:'Edit Contract Price',
			SERVICE_CH: 'Service Charge'
		},
		WAREHOUSE: {
			TITLE: 'Manage Warehouse',
			TIME: 'Lead Time (in days)',
			EDIT_WAREHOUSE: 'Edit Warehouse',
			WARE_TYPE:'Warehouse Type',
			ADD_WAR:'Add Warehouse',
			WAR_ID:'warehouse Id',
			NAME: ' Warehouse Name',

		},
		SUPPORTSCOPE: {
			// TITLE: 'Support Scope',
			NAME: ' Support Scope Name',
			TYPE: ' Price Type',
			EDIT : 'Edit Support Scope'
		},
		AMC: {
			// PRIORITY: 'Priority',
			TITLE: 'Contract Type',
			ADD_AMC: 'Add Contract Type',
 			AMC: 'Contract',
 			DURATION: 'Duration (In Month)',
 			DURATION_YEAR:'Duration (In Years)',
 			COST: 'Cost',
 			TAB_SERIAL: 'Serial No',
			EDIT_AMCDETAILS: 'Edit Contract Type',
			AD_AMCREQUIRED: 'Contract name is required',
 			// AD_AMCPATTERN: 'Strings only allowed',
 			// AD_AMCLIMIT: 'Exceeds the limit',
 			AD_DURATIONREQUIRED: 'Duration required',
 			AD_DURATIONPATTERNS: ' Numbers only allowed',
 			AD_DURATIONLIMITS: ' Duration limit upto 99 months',
			AD_COSTRQUIRED: ' Cost is required',
			// AD_COSTPATTERN: 'Numbers only allowed',
			// ED_AMCREQUIRED: 'Contract name is required',
			// AD_COSTPATTERN: 'Numbers only allowed',
 			// ED_AMCPATTERN: 'Strings only allowed',
 			// ED_AMCLIMIT: 'Exceeds the limit',
			ED_DURATIONREQUIRED: 'Duration required',
			// ED_DURATIONPATTERNS: ' Numbers only allowed',
 			ED_DURATIONLIMITS: ' Duration limit upto 99 months',
			ED_COSTRQUIRED: ' Cost is required',
			// ED_COSTPATTERN: 'Numbers only allowed',
			ED_STATUSREQ: 'Status is required',
			NW_CON: 'New Contract',
			// ED_COSTPATTERN: 'Numbers only allowed',
			// NW_CON: 'New Contract'


		},
		SERVICEGROUP: {
			TITLE: ' Service Group Management',
			ADD_SERVICE: 'Add Service Group',
			WORK_TYPE: 'Service Group',
			WORKREQ: 'Service Group is required',
			WORKPATTERN: 'Strings only allowed',
			WORKLIMIT: 'Exceeds the limit',
			EDIT_SERVICE: 'Edit Service Group',
			CHECK: 'Check list',
			ADD_CHECK: 'Add Check list',
			DESC: 'Description',
			TYPE: 'Type',
			DATE: 'Date',
			SER_GR: 'Service Group',
			EDIT_CHECK: 'Edit Checklist',
			PRODUCT_BASE: 'Product-Base',
			SELECT_SERVI_DESK:'Select Service Desk',
			SUB:'Subproduct'


		},
		PRODUCTMASTER: {
			CODE:'Product Code',
			ADDMODEL:'Add Model',
			EDITMODEL:'Edit Model',
			WARRENTY:'Warranty Type',
			// TITLE: 'Product Master',
			CATEGORY: 'Product Category',
			ADD_PROCAT: 'Add Product Category',
			// BULKPRO: 'Bulk Upload',
			ADDSUB_PROCAT: 'Add Sub Category',
			PROCAT: 'Product category',
			PRO: 'Product category',
			SUBPRO: 'Sub Category',
			SUBPRONAME: 'Sub Category ',
			// PROMODALNO: 'Model Master',
			PROMODAL:'Model Number',
			// PRODESC: 'Description',
			// CON_TY:'Contract Type',
			// SUPP_CAT:' Support Scope',
			UPDATEPROCAT: 'Update Product category ',
			UPDATESUBPROCAT: 'Update sub category ',
			IMAGE: 'Upload Image',
			VIDEO_UP: 'Upload Video',
			UPLOADPROLIST: 'Upload Product list',
			UPLOADSUBPROLIST: 'Upload Sub Category list',
			SAMPLE: 'Sample Template',
			UPLOAD: 'Upload',
			VIEW_MORE: 'View Description',
			LOGO: 'Upload Image',
			PRBLMDESC: 'must be 512 characters only',
			PART_NO: 'Part Number',
			// DESC : 'Description',
			ANN_PR: 'Annual Contract Price',
			NO_SUBPRODUCT_AVA:'No SubProduct Available',
			PRIORITY_LEVEL:'Priority Level',
			LAST_UPDATE:'Last Update ',
			SLA_UPDATE:'SLA Upate',
			SUB_PRODUCT:'Sub product',
			DROPDATE:'Dropdate required',
			LoT:'Location Type',
			// PRIO:'Priority'
			

		},
		SPAREMASTER: {
			TITLE: 'Manage Spare Master',
			ADD_SPARE: 'Add Spare',
			AD_ST: 'Add Stock',
			UPLOAD_SPARELIST: 'Upload spare list',
			// BULK_SPARE: 'Bulk Upload',
			WARE_LOCATION: 'Warehouse Location',
			SUB_PRO: 'Sub Category',
			QUANTITY_PURCHASE: 'Quantity  Purchased',
			QUANTITY_USED: 'Quantity Used',
			SPARE_IMAGE: 'Spare image',
			SPARE_CODE: 'Spare code',
			SPARE_NAME: 'Spare Description',
			PURCHASE: 'Purchase',
			EXPIRE: 'Expire',
			PRO: 'Product',
			IMAGE: 'Image',
			// DESC: 'Description',
			DATE_PUR: ' Purchase Date',
			DATE_EXP: 'Expire Date',
			SAMPLE: 'Sample Template',
			SELECT: ' Select file',
			UPLOAD: 'Upload',
			EDIT_SPARE: 'Edit Spare',
			ED_ST:'Edit Stock',
			AD_SPARENAMEREQUIRED: 'Spare name is required',
			AD_SPAREDESC: 'Description is required',
			AD_SPAREIMAGE: 'Spare image is required',
			AD_PRO: 'Product is required',
			AD_SUBPRO: 'Subproduct is required',
			AD_WARE: 'Warehouse is required',
			AD_PURQUANTITY: 'Purchased Quantity is required ',
			AD_USEQUANTITY: ' Used Quantity is required',
			AD_DATEPUR: 'purchase date is required',
			AD_DATEEXP: 'Expire date is required',
			UP_SPARE_QUAN: 'Update spare quantity',
			UP_IMPRASE_QUAN: 'Update imprest Quantity',
			ALLPRO: 'All Products',
			ALLLOC: 'All Towns',
			REQ_QUAN: 'Request Quantity',
			STOCQUAN: 'Stock Qty',
			// ALL: 'All',
			SPAREMODEL: 'Spare Model',
			PRICE: 'Price',
			VIEW_SPARE: 'View Spare',
			VIEW_STOCK: 'View Stock',
			DIGI: 'must be greater than one',
			MAX: 'maximum length is 45 characters',
			SPARE_IMG:'Spare image ',
			SPA_NAME:'Spare Name',
			// DESCRIPTION:'Description ',
			// SELECT_FILE:' Select file ',
			USED_QUAN:'Used Quantity',
			PRO_QUAN:'Purchased Quantity',
			SPARE_ID:' Spare id',
			PURCHASE_DATE:'purchase Date',
			SELECT_WARE_PLACE:'Select your warehouse place',
			SELECT_SUBPRODUCT:'Select your subproduct name',
			SELECT_PRO_NAME:'Select your product name',
			SPARE_TYPE:'Spare Type',
			SELECT_SPARE_TYPE:'Select Spare Type',
			REPAIRABLE:'Repairable',
			RETURNABLE:'Returnable',
			CONSUMABLE:'Consumable',
			TOOLS:'Tools',
			ADD_SUPPORT_SCOPE:'Add Support Scope',
			FRMDATE:'Frm Received Date',
			PCARQ:'Product category is required'



		},
		SITE: {
			TITLE: 'Manage site settings',
			ADD_SITE: 'Add Site settings',
			Edit_SITE: 'Edit Site settings',
			SITE_ID: 'Site ID',
			COPY: 'Copy Right Info',
			NOTIFY: 'Notification Elapse Time',
			TECHRADIUS: 'Technician Radius',
			COPYR: 'copyright information is required',
			NOTIFYE: 'Notification elapse time is required',
			ELAPSED: 'elapse time is only numbers',
			TECH: 'Technician radius is required',
			TECHNUM: 'Technician radius is only numbers',
			TECHASSIGNTYPE: 'Technician assigning type',
			LOGO: 'Company logo',
			TECHAR: 'Technician assigining type is required',
			PREFIX: 'Customer code Prefix',
			EPREFIX: 'Customer code prefix is required',
			DIGI: 'must be min 3 digits',
			MUST: 'must be Numbers, characters only',
			SELECT: 'Select Technician Assign Type',
			REMOVE: 'Remove',
			SELECT_ORG:'Select your org type',
			FILE: 'Choose file',
			SAVE: 'Save Changes',
			SINGLE:'Single',
			MULTI:'Multiple',
			SELECT_PAC:'Select your Package type',
			EXPORT:'Export',
			SELECT_PRO:'Select product',
			SELECT_SUB_CAT:'Select Sub Category',
			// SELECT_MODEL_NUM:'Select Model Number',
			PRO_INFO:'Product Information',
			ATT_2:'Attachment2',
			ATT_1:'Attachment1',
			ATT_DOC:'Attach Documents',
			ATT:'Attachment',
			EMAIL_TAKEN:'Email is alredy taken',
			SAVE_EXIT:'Save and Exit',
			SAVE_COUT:'Save and Continue',
			MANUAL:' Manual',
			AUTOMATIC:'Automatic',
			SELECT_MODEL:'Select Model',
			SELECT_TECH_TYPE:'Select Technician Type',
			INHOUSE_TECH:'Inhouse Technician',
			PARTNER_SER_ENGIN:'Partner Service Engineer',
			SELNODE:'Select node',
			SELSUB_PRO:'Select Sub product',
			PDREQ:'Product image is required',
			CPBUP:'Contractprice Bulkupload',
			REDEL:'Region Details',
			CUPRDES:'Customer Problem Description',
			ACCDATE:'Accepted date',
			ACC:'Accepted ',
			REACC:'Reason for Accept',
			SERE:'Select Reason',
			GW:'Good Will',
			WAEX:'Warranty Expiry',
			// RE:'Reason',
			// SAEX:'Save and Exit'
		},
		SMTP: {
			TITLE: 'Manage SMTP settings',
			ADD_SMTP: 'Add SMTP',
			EDIT_SMTP: 'Edit SMTP',
			HOSTNAME: 'Host Name',
			USER: 'User name',
			USEREmail: 'User name(Email)',
			PASS: 'Password',
			PORT: 'Port',
			SECTYPE: 'Security type',
			AD_EMAILREQUIRED: 'User name is required',
			MIN: 'minimum length is 6',
			TYPE: 'Select Security Type',
			DIGI: 'is must be numbers only',
			MINI: 'minimum length is 2',
			MAX: 'maximum length is 4',
			SSL:'SSL',
			TLS:'TLS',
			SMTP_ID:' SMTP Id'

		},
		ORG_STR: {
			ORG_STR: 'Organization Structure',
			// BULK: 'Bulk Upload',
			SAMPLE: 'Sample Template',
			// SELECT: ' Select file',
			UPLOAD: 'Upload',
			BULKORG: 'Organization bulk upload',
			DEL: 'Delete',
		},
		COM:{
			ADD:'Add Compensation',
			EDIT:'Edit Compensation'
		},
		SMS: {
			SMS: 'SMS',
			ADDGATE: 'Add Gateway',
			ADD_SMS: 'Create SMS settings',
			EDIT_SMS: 'Update SMS settings',
			GATEWAY: 'Gateway name',
			URL: 'Url',
			URLR: 'Url is required',
			GATE: 'Gateway Name',
			GATER: 'Gateway is required',
			URLRP: 'http://example.com',
			PARAM: 'Parameter',
			LABEL: 'Label Name',
			VALUE: 'Value'
		},


		CUSTOMER: {
			CUSLOG:'Customer Login Creation',
			// TITLE: ' Customer Management',
			// BULK: 'Bulk Upload',
			SAMPLE: 'Sample Template',
			// SELECT: ' Select file',
			UPLOAD: 'Upload',
			BULKCUS: 'Customer bulk upload',
			// CUSID: 'Customer Id',
			// CONNAME: 'Contact Name',
			// CONNUM: 'Contact Number',
			VIEW: 'View Contract Info',
			// CLOSE: 'Close',
			DURATION: 'Contract Duration',
			CUSCODE: 'Customer code',
			// LAND: 'LandMark',
			// POSCODE: 'Postal Code',
			BULKDON: 'Bulk download',
			// NAME: ' Name',
			// MONUM: 'Model',
			// SUPP_CAT : 'Support Scope',
			PAR_NO: 'Part Number',
			SELNO: 'Serial Number',
			CON_VAL: 'Contract Value',
			ST_DA: 'Start Date',
			DOC: 'Documents',
			// CONNUMBER: 'Contact Number ',
			// ALTCONNUMBER: 'Alternate Number',
			CONTRACT: 'Contract Category',
			PRODUCT: 'Product category',
			SUBPRODUCT: 'Sub category',
			COND: 'Contract Details',
			ID: 'ID',
			CONTYPE: 'Contract Category',
			PROC: 'Product Category',
			SUBC: 'Sub Category',
			// END: 'End Date',
			EDITC: 'Edit Customer Detail',
			VIEWC: 'View Customer Detail',
			EDITCO: 'Edit Contract Detail',
			VIEWCO: 'View Contract Detail',
			CONL: 'Customer Address',
			ENTER: 'Enter',
			CREATE_PASS:'Create Password',
			RAISED_DATE:'Raised Date',
			SELECT_CONT_CATE:'Select contract Category',
			SELECT_SUPP_SCOPE:'Select Support scope',
			PRICE_TYPE:'Price type',
			SELECT_PRI_TYPE:'Select Price type',
			CREATE_NEW_CUS:'Create New Customer',
			CUS_INFO:'Customer info',
			PRO_PRODUCT_INFO:'Provide Product Info',
			CH:'512 characters only',
			SLATA:'SLA Complaince Target (in %)',
			SHIADIN:'Shipping Address Info',
			PROCOIN:'Provide Contract Info'



		},
		
		USER: {
			SERVICE:'Service Desk',
			TITLE: 'User Management',
			TITLE_PRO: 'Profile',
			// COMPANY_INFO: 'Company Info',
			FULLNAME: 'First Name',
			LAS_NA: 'Last Name',
			// CONNUMBER: 'Contact Number ',
			// CONALTNUMBER: 'Alternate Number',
			NAME: ' Username',
			EMPCODE: 'Employee ID',
			// USERNAME: 'Name',
			ROLE: 'Role',
			// ADDRESS: 'Address',
			// PLONO: 'Door/Plot No',
			// LAND: 'LandMark',
			// CLOSE: 'Close',
			// POSCODE: 'Postal Code',
			// LOCATION: 'Town',
			NODE: 'Node',
			// REQ: ' is required',
			VALID: 'Please enter a valid',
			// DIGI: 'must be 10 digits',
			// MUST: 'must be in 6 digits',
			// NEXT_STEP: 'Next Step',
			ADD: 'Add User',
			ADDO: 'Add',
			EMPID: 'Employee ID',
			PRODUCT: 'Product',
			SUBPRODUCT: 'Sub category',
			SKILL: 'Skill Level',
			WORK: 'Service Group',
			// WORKP: 'Work Profile',
			BULKUP: 'Bulk Upload',
			USER: 'User',
			TECH: 'Technician',
			TECHI: 'Technician Image',
			VPL: 'View Product list',
			EDIT: 'Edit',
			UPLOAD: 'Upload',
			SAMPLE: 'Sample Template',
			CHCL: 'Edit Town',
			CP: 'Assign Product ',
			PD: 'Product Details',
			// CONNAME: 'Contact Name',
			ACPT_NO: 'Accept only numbers',

		},
		RAISETCKT: {
			VOLTAGE:'Voltage',
			// TITLE: 'Raise Ticket',
			CUSID: 'Customer ID',
			CONPERNAME: 'Contact Person name',
			CONPERNUM: 'Contact Person name',
			MFGDATE:' Manufacturing Date',
			WARRANTYDUR:'Warranty Duration',
			INVOICEDATE:'Invoice Date',
			CUS_CODE: 'Customer Code',
			CUS_INFO: 'Customer Info',
			CONNUMBER: 'Contact Number ',
			INVOICENUM:'Invoice Number',
			// NAME: 'Name',
			CONALTNUMBER: 'Alternate Number',
			// DOPLO: 'Door/Plot No',
			STRS: 'Street',
			// TOWN: 'Town',
			LAND: 'LandMark',
			CITY: 'City',
			LOCATION: 'Town',
			COUNTRY: 'Country',
			STATE: 'State',
			POSCODE: 'Postal Code',
			SERIAL_NO: 'Serial.No',
			// CONRCT_TYP: 'Contract Type',
			PRODUCT: 'Product',
			SUBPRODUCT: 'Sub category',
			EXP_DATE: 'Expire date',
			DIGI: 'must be 10 digits',
			MUST: 'must be in 6 digits',
			RESET: 'Reset',
			GO: 'Go',
			REQ: 'is required',
			PRODUCT_CATEGORY: 'Product Category',
			SUB_CATEGORY: 'Sub Category',
			DATE_OF_PURCHASE: 'Date of Purchase',
			// CONTRACT_TYPE: 'Contract Type',
			// MODEL_NO: 'Model ',
			SYSAH: 'Sys AH',
			CONTRACT_DURATION: 'Contract duration (in Months)',
			CONTRACT_PER: 'Contract period (in Months)',
			EMAIL_ID: 'Email ID',
			// CONTACT_NO: 'Contact Number',
			WORK_TYPE: 'Service Group',
			CALL_CATEGORY: 'Call Category',
			DATE_TIME: 'Prefered Date-Time',
			UPLOAD_IMG: 'Upload Image',
			PROBLEM: 'Problem Description',
			SELECT_LOC: 'Select Town',
			SELECT_OPT: 'Select Your option',
			SELECT_SUBPROD: 'Select Sub category',
			SELECT_PROD: 'Select Product',
			SELECT_CALLCAT: 'Select Call category',
			SELECT_WORKTYP: 'Select Service Group',
			SELECT_PRI: 'Select Priority',
			// BACK_BUTTON: 'Back',
			PROVIDE_PROD_INFO: 'Provide product Info',
			// PRIORITY: 'Priority',
			SOURCE: 'Source',
			DESIGNATION: 'Designation',
			MODEOFTRAVEL: 'Mode of Travel',
			NOOFKM: 'No of Km',
			CLAIMS: 'Claims',
			ATTACHEMENT: 'Attachments',
			ATTACH:'Attachment',
			VIEW: 'View',
			CONPER: 'Contract Period',
			QUN: 'Quantity',
			PREDATM: 'Preferred Datetime',
			RENCON: 'Renew Contract',
			ENTER_MODAL: 'Enter Model Number',
			ENTER_SERIAL: 'Enter Serial Number',
			P_SERIAL: 'Product Serial No',
			ENTR_DES: 'Enter Description',
			ECUSID: 'Enter Customer Id',
			SITE_ID:'Site ID',
			CONNAME:'Contact Person Name',
			CONPERNUMBER:'Contact Person Number',
			BBID:'Battery Bank ID',
			BILLING_ID:'Billing ID',
			ASSET_ID:'Asset ID',
			EDIT_ASSET_DET:'Edit Asset Details',
			S_NO:'S.NO',
			ERROR:'Error',
			LARGE:'is too large',
			SELECT_SUBPRO:'Select Subproduct',
			SELECT_LOCA:'Select Location',
			SUBPRODCT:'Subproduct',
			SELECT_CONT_TYPE:'Select your content type',
			P1:'P1',
			P2:'P2',
			P3:'P3',
			P4:'P4',
			SPARE_IMAGE:'Spare Image',
			SELECT_ROLE:'Select Role',
			LOFRE:'Location Field is requied',
			SEBILID:'Select Billing Id',
			GS:'GSTN',
		},
		NEWTCKT: {
			SERIAL:'Serial Number',
			TITLE: 'New Ticket',
			TCKID: 'Ticket ID',
			TCH_ID: 'Technician ID',
			TCH_NAME: 'Technician Name',
			TCH_DET: 'Technician details',
			SK_LVL: 'Skill Level',
			TA_PR: 'Tasks Present',
			CUS_NAME: 'Customer Name',
			// CONNUMBER: 'Contact Number ',
			CUR_LOC: 'Current Location',
			// LOC: 'Town',
			TCKT_TYP: 'Ticket Type',
			PRODUCT: 'Product Category',
			SUBPRODUCT: 'Sub Category',
			// MODEL: 'Model',
			PART_NO: 'Part Number',
			CON_CAT:'Contract Category',
			SUP_SC: 'Support Scope',
			// PR_TYPE: 'Price Type',
			EX_DATE:'Expiry Date',
			TCKTSTS: 'Ticket Status',
			ASIGN_TM: 'Assigned Time',
			DATE: 'Date',
			PRF_DATE: 'Preferred Date',
			RAIS_TM: 'Raised Time',
			ASSIGN: 'Assign',
			REASSIGN: 'Re-assign',
			ASSIGNT: 'Assign to',
			BULK: 'Bulk upload',
			CALLCAT: 'Call Category',
			SERVCAT: 'Service Category',
			PROB: 'Problem Description',
			PRI: 'Priority',
			UPLOAD: 'Upload',
			// ACTIONS: 'Actions',
			TSK_CNT: 'Task Count',
			EDIT_DIFF: 'Edit Deffered Ticket',
			ASIGN_TO: 'Assigned to',
			SAMPLE: 'Sample Template',
			DATEOFINVOICE: 'Date of Invoice',
			DATEOFDELI: 'Date of Delivery',
			CRD: 'Customer Requested Date',
			DOC: 'Date of Completion',
			VERTICAL: 'Vertical',
			REMARK: 'Remarks(status)',
			SUMREPORT: 'Summary Report',
			SPAREREPORT: 'Spare Report',
			TECHREPORT: 'Technician Report',
			CALLTYPE: 'Call Type',
			FRMREPORT: 'Field Return Material Report',
			FRMDETAIL: 'FRM Details',
			DOFRM: 'Date of FRM',
			TAMT: 'Ticket Amount',
			QRETURN: 'Quanity Returned',
			REVENUEREPORT: 'Revenue Report',
			CURRENT_LOC: 'Current Location',
			LOCATION:'Location',
			CONTRACT_TYPE:'Contract type',
			PROBLEM:'Problem',
			TIC_HIS:'Ticket History',
			DURATION:'Duration(In years)',
			SELECT_TOWN:'Select town',
			ALL_PRODUCTS:'ALL Products',
			ALL_TOWNS:'ALL Towns',
			ACC_TIME:'Accepted Time',
			SERTCT:'Service Ticket',
			AMCTCT:'Amc Ticket',
			GS:'GSTN',
			SESTA:'Select status',
			TCT:'Ticket',
			CUCOBU:'Customer Contract Bulk Upload ',
			ADEN:'Add enduser',
			ENUSNAME:'Enduser Name',
			ENCONUM:'Enduser Contact Number',
			ENEM:'Enduser Email',
			CUSCON:'Customer Contract',
			CONEM:'Contact Email',
			BISASHIP:' Billing addrress same as Shipping Address',
			DIFFB:'Different Billing Address',
			BILLIN:'Billing Info',
			ENCONA:'Enduser Contact Name',
			WRKTYP:'Service Group'
		},

		ONGO: {
			TITLE: 'OnGoing Tickets',
			// CUS_NAME: 'Customer Name',
			// TECH_ID: 'Technician id',
			VISIT: 'Next Visit',
			REASON: 'Reason',
			START_TIME: 'Start Time',
			ESCALATE: 'Suggested Technician ID',
			PRE_TECH: 'Previous Technician ID',
			PRODUCT_CATEGORY: 'Product Category',
			SUB_CATEGORY: 'Sub Category',
			SPARE_REQUEST: 'Spare Requested',
			REQUEST_SPARE: ' Requested Spare(s)',
			LEAD: 'Lead Time',
			ACTION: 'Plan Of Action'
		},

		COMTICK: {
			// TITLE: 'Completed Tickets',
			// TECH_ID: 'Technician id',
			PRODUCT_CATEGORY: 'Product Category',
			SUB_CATEGORY: 'Sub Category',
			COM_TIME: 'Completed Time',
			CLOSE_TIME: 'Closed Time',
			CUST_FEED: 'Customer Feedback',
			CUST_RATE: 'Customer Rating',
			DOWNLOAD: 'Download',
			CUSRAT: 'Customer Rating',
			CUSCOMNT: 'Customer Comments'
		},
		REGION: {
            // TITLE : 'Region',
			// BULKUP : 'Bulk Upload',
			ADD : 'Add',
			// SERIAL_NO :'S.No',
			STATES : 'States',
			// REGION: 'Region',
			CITYS:'Citys',
			ADD_RE: 'Add Region',
			SELECTREGION: 'Select Region',
			EDIT_RE :'Edit Region'
		},

		LOCATE: {
			// TITLE: 'Town',
			ADD: 'Add',
			// LOCAL: 'Town',
			HILL:'Hill Area',
			ADD_LOCATE: 'Add Town',
			Edit_LOCATE: 'Edit Town',
			LOCATEID: 'Town ID',
		},
		KNBS: {
			TITLE: 'Knowledge Base',
			SOL: 'Solution',
			IMG: 'Image',
			VID: 'Video',
			PRDSC: 'Product Description',
			SUBPRO: 'Sub category',
			PRO: 'Product',
			IMVW: 'Image View',
			VIVW: 'Video View',
			AWAPL: 'Awaiting Approvals',
			PRBDESC: 'Problem Description',
			UB_KNO: 'Update Knowledge Base',
			ADD_BAS: 'Add to Knowledge Base',
			KN_BASE: 'Knowledge Base Type',
			SUBPRODUCT:'SubProduct',
			ASSIGN_TECH:'Assigned Technician',
			CREATE_DATE:'Created Date',
			RESPONSE_TIME:'Response Time ',
			DAY:'Day',
			H:'Hrs',

		},

		CONFIG: {
			TITLE: 'Service Desk Metrix',
			WHEELER2: 'Two Wheeler Per Km',
			WHEELER4: 'Four Wheeler Per Km',
			PGST: 'Product GST',
			SGST: 'Service GST',
			CALLCAT: 'Call Category',
			MTREPAIR: 'Mean Time To Repair',
			EDIT: 'Edit Call Category',

		},
		LEAD: {
			TITLE: 'LeaderBoard',
			RANK: 'Rank',
			// TCH_ID: 'Technician Id',
			TCH_NAME: 'Technician Name',
			SCORE: 'Score',
			LEVEL: 'Level'
		},

		SPARE: {
			TITLE: 'Ticket Spare Request',
			NEW: 'New Spares',
			APPROVED: 'Approved Spares',
			REJECT: 'Rejected Spares',
			// TECHID: 'Technician ID',
			SPAREREQ: 'Spare Required',
			// CONTRACT: 'Contract Type',
			AMT: 'Amount',
			CUSTAPP: 'Customer Approval',
			SPARECODE: 'Spare code',
			SPA_NAME:' Spare Description',
			MODEL: 'Model',
			PRODUCT: 'Product',
			SUBPRODUCT: 'Sub Category',
			SPAREREQUIRED: 'Spare Required',
			SPARELOCATION: 'Spare Location',
			CHARGABLE: 'Chargeable',
			SLCTPRO: 'All Products',
			SLCTLOC: 'All Towns',
			SLCTSUBPRO: 'All Sub category',
			SPAREREQT: 'Ticket Spare',
			// PRI_TY: 'Price Type',
			// SUPP_SCO:'Support Scope',
			SUB_TO: 'Sub Total',
			DIS_TY: 'Discount Type',
			DIS_AMT: 'Discount Amount',
			DIS:'Discount',
			TOT_AMT:'Total Amount',
			SELECT_DIS:'Select discount type',
			SELECT_PRT:'Select Price Type',
			LABOUR:'Labour Only',
			PARTS:'Parts Only',
			LA_PAR:'Labour & Parts',
			NONE:'None',
			YES:'Yes',
			NO:'No',
			SUCCESS:'Success',
			PRICE:'Price(Annually)',
			SELECT_DIS_TYPE:'Select Discount type',
			PRINT:'print',
			FIELD:'Field is requied',
			MINS:'Mins',
			SELECT_SLA:'Select SLA Target',
			RESOLU_TIME:'Resolution Time',
			ACC_TIME:'Acceptance Time',
			RES_DAY_REQ:'response_day is required',
			STOCK_TYPE:'Stock Type',
			NEW_SPARE:'New spare',
			RMA:'RMA',
			SELECT_SPARE_CODE:'Select Spare Code',
			SELECT_WAREHOUSE:'Select Warehouse',
			STOCK_CATE:'Stock Category ',
			SELECT_STOCK_CATE:'Select Stock Category',
			SUCESS:'Success ',
			STOCK_ID:'Stock id ',
			SPARE_ID:'Spare id',
			ADD_SPARE:'ADD Spare',
			SUPPORTSCOPE_ID:'Supportscope ID',
			TECH_TYPE:'Technician Type',
			PRIANN:'Price (Annually)',
			SEDISTY:'Select Discount Type'


		},
		MANAGECONT: {
			TITLE: 'Manage Contract',
			// CUSID: 'Customer ID',
			PROCAT: 'Product',
			PROMODEL: 'Product Model No',
			// SERIALNO: 'Serial No',
			// CONTYPE: 'Contract Type',
			MODE: 'Mode of Payment',
			CONAMT: 'Contract Amount',
			DETAILS: 'Customer Details',
			IMAGE: 'Reimbursement Image',
			DETA:'Details'

		},
		TRAININGSCORE: {
			// TITLE: 'Training Score',
			TYPE: 'Training Type',
			ASSESSMENT: 'Assessment',
			DATE: 'Date',
			TECH: 'Technician',
			EMPID: 'Employee ID',
			TECHN: 'Technician Name',
			PRO: 'Product',
			SUBPRO: 'Sub category',
			SCORE: 'Score',
			REPORTFROM: 'The Report From',
			TO: 'To',
			CBO: 'Calls B/O from previous week',
			BOC: 'B/O calls closed this week',
			CURRLOGCALL: 'Current week`s Calls Logged',
			CLOSECALL: 'Current week`s Closed Calls	',
			BOPEN: 'B/O calls Open for this week	',
			COPEN: 'Current week`s Open Calls',
			CFCALL: 'Calls C/F',
			SERVICEGROUP: 'Service Group',
			CALLREPORT: 'Call Report',
			INTIME: 'In Time',
			OUTTIME: 'Out Time',
			AVAIL: 'Availability',
			ATTENTANCER: 'Attendance Report',
			FROMDATE: 'From Date',
			TODATE: 'To Date',
			EXCEL: 'Excel',
			// STATUS:'Status',
			NO_RECORDS:'No records found',
			SELECT_FEEDBACK:'Select Feedback',
			PRODUCT_INFO:'Product info',
			SELECT_SERVICEGROUP:'Select Service Group',
			SELECT_SKILLEVEL:'Select skill level',
			CATREQ:'Sub Category name is required',
			SUBREQ:'SubCategory is required',
			PDNAREQ:'Product name is required',
			SEPRNA:'Select  your product name',
			// pre:'Previous',
			PROBA:'Product-Base'


		},
		REIM: {
			// TITLE: 'Reimbursement',
			NEWC: 'New Claims',
			// TECHID: 'Technician ID',
			TECHN: 'Technician Name',
			START: 'Start Date',
			END: 'End Date',
			CLAIMAMT: 'Claim Amount',
			VIEW: 'View Form',
			APPROVED: 'Approved Claims',
			REJECT: 'Rejected Claims',
			DROPDATE:'Drop Of Date'

		},
		TRANSFERSPARE: {
			// TITLE: 'Spare Transfer Request',
			// SPARETRANSFER: 'Spare Transfer Request',
			APPROVED: 'Approved Spare',
			REJECT: 'Rejected Spare',
			FROMT: 'From Technician',
			SPAREDETAILS: 'Spare Details',
			SPAREQUANTITY: 'Spare Quantity',
			SPARECODE: 'Spare Code',
			SPA_NAME:' Spare Description',
			DETAILS: 'Technician Details',
			REQUESTQUANTITY: 'Spare Quantity',
			LOCATION: 'Spare Location',
			TICKETDETAILS: 'Ticket Details',
			TOT: 'To Technician',
			SPARE: 'Spare Required',
			FRM_S: 'FRM Status',
			TRC_UPDATE:'Update TRC',
			NO_DATA:' No Data  Available',
			ALL_TICKETS:'ALL Tickets',
			TODAY:'Today',
			THIS_WEEK:'This Week',
			THIS_MONTH:'This Month',
			THIS_YEAR:'This Year',
			WORK_TYPE_ID:'Service Group Id',
			SERVICE_ID:'Service Id',
			SELECT_CATE:'Select Category',
			YES_NO:'Yes/No',
			TEXT:'TEXT',
			DAY:'Day',
			SUBCAT:'Sub Categories',
			SUBRE:'Subproduct image is required',
			ALLLEV:'ALL Levels',
			LE1:'Level 1',
			LE2:'Level 2',
			LE3:'Level 3',
			LE4:'Level 4',
			EDITCDEL:'Edit Ticket Details',
			REJ:'Rejected'


		},
		COMPLETEDTICKETS: {
			TITLE: 'Completed tickets',
			SLNO: 'Serial Number',
			CLOSEDTIME: 'Closed Time',
			CUSTOMERFEEDBACK: 'Customer Feedback',
			CUSTOMERRATING: 'Customer Rating',
			// DOWNLOAD: 'Download',
			FEED: 'Feedback'

		},
		IMPRESTSPARE: {
			// TITLE: 'Imprest Spare Request',
			NEWSP: 'New Spare',
			APPROVED: 'Approved Spare',
			// TECHID: 'Technician Id',
			TECHN: 'Technician Name',
			SPARE: 'Spare Required',
			NAME: 'Name',

		},
		BUTTON: {
			NEXT: 'Next',
			UP: 'Upload',
			// DOWN: 'Download',
			// PRE: 'Previous',
			SUBMIT:'Submit',
			// NEXT_STEP:'Next Step'
		},
		PERFOM: {
			// TITLE: 'Performance Metrix',
			TECHL: 'Technician Level',
			LEV1: 'Level-1',
			LEV2: 'Level-2',
			LEV3: 'Level-3',
			LEV4: 'Level-4',
			TERMS: 'Terms',
			TARGET: 'Target',
			REWARD: 'Reward',
			AVGCALL: 'Average Calls/Day',
			FIRST: 'First-time Fix Rate/Month(%)',
			SERVICE: 'Service Contract Revenue/Month',
			CUSTOMER: 'Customer Rating',
			CONTRIBUTION: 'Contribution to KB/Month',
			TRAINING: 'Training & Certification/Month',
			SLAADHERE: 'SLA adherence/Month(%)',
			CUSTOMERFEED: 'Customer Feedback(%)',
			MTTR: 'MTTR Target/Month(%)',
			FIELDS: 'Fields are required',
			EDIT_TARGET: 'Edit Performance Metrix',
			L1:'L1',
			L2:'L2',
			L3:'L3',
			L4:'L4',
			L5:'L5',
			ALPHA:'Alphabets only',
			REUP:'Reward Upto 100%',
			TAUP:'Target Upto 100%'
		},
		CONTENT: {
			ADDTRAINING: 'Add Training',
			CREATECONTENT: 'Create Training',
			TRAINNAME:'Training name',
			TRAINTYPE:'Training Type',
			CONTENT:'Content',
			ADDASSESSMENT:'Add Assessment',
			ASSESSNAME:'Assessment Name',
			ASSESSTYPE:'Assessment Type',
			TITLE:'Training Title',
			SELECTTYPE:'Select Training Type',
			SELETPRO:'Select Product',
			SELECTSUBPRO:'Select SubCategory',
			THUMBIMAGE:'Training Thumb Image',
			SELECTCONTYPE:'Select Content type',
			UPLOADCONTENT:'Upload Content',
			EDITUPLOADCONTENT:'Edit Upload Content',
			GENERIC_TRAINING:'Generic Training',
			PRODUCT_TRAINING:'Product Training',
			TRAINING_TYPE:'Training Type is required',
			QUESTION_ASSESS:'Questions to Assessment',
			SELECT_QUES_ASESS:'Select Question to Assessment',
			ASSESS_REQ:'Assessment is required',
			THRESHOLD:'Threshold',
			SELECT_THRESHOLD:'Select Threshold',
			THRESHOLD_REQ:'Threshold is required',
			ANS:'Answer is required',
			SELECT_OPT:'Select Option',
			EDIT_QUIZ:'Edit Quiz',
			QUES:'Question is required',
			QUESTION:'Question',
			OPTION_D:'Option D',
			OPTION_C:' Option C',
			OPTION_B:'Option B',
			OPTION_A:'Option A',
			THESE_FIE_MAT:'These fields match',
			OPT_REQ:'Option is required',
			PDF:' PDF',
			WORD:'WORD',
			VIDEO:'VIDEO',
			LINK:'LINK',
			ENTER_VALID_URL:'Please enter valid url',
			CONTENT_TYPE:'Content Type',
			SELECT_CON_TYPE:'Select Content Type',
			CON_TYPE_REQ:'Content type is required',
			TITLEE:'Title',
			TRAINING_TIT_REQ:'Training Title is required',
			GENERIC_ASSESS:'Generic Assessment',
			PRODUCT_ASSESS:'Product Assessment',
			ASSESS_TYPE_REQ:'Assessment Type is required',
			EDIT_ASSESS_QUIZ:'Edit Assessment Quiz',
			ADD_QUIZ:'Add Quiz',
			CORRECT_ANS:'Correct Answer',
			ASSESS_NAME:'Assessment Name ',
			ASSESS_NAME_REQ:'Assessment Name is required',
			CREATE_ASSESS_QUIZ:'Create Assessment Quiz',
			CREATE_QUIZ:'Create Quiz',
			CONTENT_REQ:'Content is required',
			ENTER_URL:'Enter valid URL',
			TRAINING_THUMB_IMAGE:'Training Thumb Image ',
			SELECT_SUBPRODUCT:'Select Sub Product',
			NO_CUS_FEEDBACK:' No Customer Feedback',
			SELECT_RATING:'Select Rating',
			SELCONTYPE:'Select Contract Type',
			MBUP:'Model Bulkupload',
			// APPID:'Application Id',
			GEN:'Generic'






		},
	    CON_EXP: {
			CONTRACTEX : 'Expired Contract Report',
		},
		WEB_FORM: {
			OPEN: 'Open'
		}

	}


};